/**
 *
 * @param divs {Object} - Drive service div object
 */
export default function getCouponWidgetTheme(divs) {
        let theme = null;
        divs.some((div) => {
                let couponRow = div.div_rows.find(row => row.coupon_data);
                if(couponRow) {
                        theme = couponRow.coupon_data.themes[0];
                        return true;
                }
        })
        return  theme;
}